// extracted by mini-css-extract-plugin
export default {"settingsItem":"settings-item_settingsItem__BI0zP","text":"settings-item_text__8mTCt"};